import type { BridgeServiceEligibilityStatus } from '@gh/common/models'

export class BridgeCoverageWaitTimeoutError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'BridgeCoverageWaitTimeoutError'
  }
}

export class BridgeCoverageFailureError extends Error {
  readonly status: BridgeServiceEligibilityStatus

  constructor(message: string, status: BridgeServiceEligibilityStatus) {
    super(message)
    this.name = 'BridgeCoverageFailureError'
    this.status = status
  }
}
